import React, { useState, useEffect } from 'react';

function ApriElementoDiLista({
  id,
  apriElemento,
  testo,
  obsoleto
}) {

  let className = 'pointer dim b'
  
  if (obsoleto) {
    className = 'pointer black-30 strike dim b'
  }

  return (
    <div 
        className={className}
        onClick={()=>apriElemento(id)}>
            {testo}
        </div>
  )
}

export default ApriElementoDiLista;